import { RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse, HttpResponse } from 'app/types-shared';
import { OptionsRequestParams } from '../ui/form/types';
import { ApiToUse } from 'app/infrastructure/simple-form/types';
import { RemoteData } from 'app/infrastructure/remote-data';

export const api = {

  getOptions: async (componentEndpoint: string, loadOptionsParams: OptionsRequestParams,
    optionsParams: any, apiToUse: ApiToUse): Promise<HttpResponse<ApiResponse<any>>> => {
    const remote = apiToUse === ApiToUse.ADMINAPI ? RemoteAdminData : RemoteData;
    return new remote(componentEndpoint).resource<HttpResponse<ApiResponse<any>>>()
      .filter({
        ...loadOptionsParams,
        ...optionsParams
      }).all();
  }
};
